import React from 'react';

export default function usePrevious<T>(element: T) {
  const el = React.useRef<T>(element);
  const last = React.useRef<T | null>(null);

  last.current = el.current;
  el.current = element;

  return last;
}
